import { getActiveBuildings } from "./index24.js";
import { addDoorsToCores } from "./index34.js";
import { addDoorsToEntrances } from "./index35.js";
import { addDoorsToTechnicalSpaces } from "./index38.js";
import { addEntranceOpeningsToCorridors } from "./index39.js";
import { addExitDoorsToCores } from "./index40.js";
import { addOpeningsBetweenCorridors } from "./index41.js";
import { addFireDoorsToCorridors } from "./index46.js";
import { isBuildingSprinklered } from "./index47.js";
const pipeAddOpenings = ([parent, { buildingIds, aggProps }]) => {
	const dataset = aggProps.dataset;
	const buildings = getActiveBuildings(parent, aggProps);
	const aggConfig = dataset.aggConfig;
	for (const building of buildings) {
		if (buildingIds && !buildingIds.includes(building.uuid)) continue;
		addDoorsToEntrances({
			building,
			dataset
		});
		addExitDoorsToCores({
			building,
			dataset
		});
		addDoorsToCores({
			building,
			dataset
		});
		addDoorsToTechnicalSpaces({
			building,
			dataset
		});
		addOpeningsBetweenCorridors(building);
		addEntranceOpeningsToCorridors(building);
		addFireDoorsToCorridors({
			building,
			dataset,
			isSprinklered: isBuildingSprinklered(building, aggConfig)
		});
	}
	return [parent, void 0];
};
export { pipeAddOpenings };

//# sourceMappingURL=index48.js.map